import { trustItems } from '@/mocks/categories';

export default function TrustBar() {
  return (
    <section className="bg-background-100 border-y border-background-200/70">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6 py-4 md:py-5">
        <div className="flex flex-wrap items-center justify-center gap-3 md:gap-8">
          {trustItems.map((item) => (
            <div key={item.label} className="flex items-center gap-1.5 text-xs md:text-sm text-foreground-700">
              <i className={`${item.icon} w-4 h-4 flex items-center justify-center text-accent-500`}></i>
              <span className="whitespace-nowrap">{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}